import { formatDateNoTime } from "./util/date";
export const defaultSignatureEmailSubject = "Your signature is requested";
export const defaultSignatureEmailBody = "<p>Your signature is requested. Please click on this link: {{link}}</p>";
export var SignatureFieldType;
(function (SignatureFieldType) {
    SignatureFieldType["Text"] = "Text";
    SignatureFieldType["Checkbox"] = "Checkbox";
    SignatureFieldType["Date"] = "Date";
    SignatureFieldType["Signature"] = "Signature";
    SignatureFieldType["Initial"] = "Initial";
})(SignatureFieldType || (SignatureFieldType = {}));
export var SignatureCheckboxFieldUnicode;
(function (SignatureCheckboxFieldUnicode) {
    SignatureCheckboxFieldUnicode["Checked"] = "\u2611";
    SignatureCheckboxFieldUnicode["Unchecked"] = "\u2610";
})(SignatureCheckboxFieldUnicode || (SignatureCheckboxFieldUnicode = {}));
export const getSignatureCheckboxFieldSymbol = (fieldBooleanValue) => {
    return fieldBooleanValue
        ? SignatureCheckboxFieldUnicode.Checked
        : SignatureCheckboxFieldUnicode.Unchecked;
};
export const formatSignatureFieldValue = (field) => {
    switch (field.fieldType) {
        case SignatureFieldType.Date:
            return formatDateNoTime(field.textValue ?? "", "");
        case SignatureFieldType.Checkbox:
            return getSignatureCheckboxFieldSymbol(field.booleanValue ?? false);
        default:
            return field.textValue ?? "";
    }
};
export const getFieldTypeFontFamily = (fieldType) => {
    switch (fieldType) {
        case SignatureFieldType.Signature:
        case SignatureFieldType.Initial:
            return "'Parisienne', cursive";
        case SignatureFieldType.Checkbox:
            return "'Source Sans Pro', sans-serif";
        default:
            return "'Roboto', sans-serif";
    }
};
export const getFieldTypeFontFilename = (fieldType) => {
    return `${getFieldTypeFontFamily(fieldType)
        .replace(/ /g, "")
        .replace(/'/g, "")
        .split(",")[0]}-Regular.ttf`;
};
//# sourceMappingURL=signature.js.map